export default __webpack_public_path__ + "static/media/srch-on.0555cce7.svg";